<template>
  <v-container>
    <BookingDetailsModal
      :isShow="isDetailsShow"
      :booking="selectedItem"
      :details="details"
      @close="isDetailsShow = false"
    ></BookingDetailsModal>
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="alert" :timeout="2000" color="error" top>
      <v-icon>mdi-alert</v-icon>
      &nbsp;&nbsp;您没有访问权限，系统将会跳转。
    </v-snackbar>
    <v-tabs v-model="selectedTab">
      <v-tab v-for="item in tabs" :key="item.tab">
        {{ item.tab }}
      </v-tab>
    </v-tabs>
    <v-row>
      <v-col v-show="selectedTab == 1" cols="12" sm="4" md="4" xs="4">
        <v-autocomplete
          v-model="selectedEventType"
          item-text="Name"
          item-value="Identity"
          :items="eventType"
          return-object
          label="预定模板"
        >
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0">
              <span>{{ selectedEventType.Name }}</span>
            </span>
            <span v-if="index === 1" class="grey--text caption"
              >&nbsp;(+{{ selectedEventType.length - 1 }} 其它)</span
            >
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="3" md="3" xs="3">
        <v-menu
          v-model="startMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="startDate"
              label="开始日期"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="startDate"
            @input="startMenu = false"
            locale="zh-cn"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="3" md="3" xs="3">
        <v-menu
          v-model="endMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="endDate"
              label="结束日期"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="endDate"
            @input="endMenu = false"
            locale="zh-cn"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="2" md="2" xs="2">
        <v-btn
          color="green"
          class="mt-2"
          style="width: 100px"
          dark
          @click="run()"
          >查询</v-btn
        >
      </v-col>
    </v-row>
    <v-card>
      <v-card-title>
        查询结果

        <v-spacer></v-spacer>

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="筛选"
          single-line
          hide-details
        ></v-text-field>

        <vue-excel-xlsx
          :data="bookings"
          :columns="columns"
          :filename="'导出数据'"
          :sheetname="'Result'"
          class="ml-5"
        >
          <v-btn color="blue" class="mt-2" style="width: 100px" dark
            >导出</v-btn
          >
        </vue-excel-xlsx>
      </v-card-title>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="bookings"
        :search="search"
        :items-per-page="10"
        class="elevation-1"
      >
        <template v-slot:item.description="{ item }">
          <!-- <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon color="grey lighten-1">mdi-information-outline</v-icon>
            </v-btn>
            <v-icon v-if="isNew(item)">mdi-new-box</v-icon>
          </template>
          <span> {{item.description}}</span>
        </v-tooltip>-->
          <v-icon @click="showBookingDetails(item)">mdi-details</v-icon>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import BookingDetailsModal from "@/components/BookingDetailsModal";
import { eventTemplateService } from "@/api/event-template.service";
import { reportService } from "@/api/report.service";
import moment from "moment";

export default {
  name: "reportService",
  components: { BookingDetailsModal },
  data: () => ({
    tabs: [{ tab: "按日期查询" }, { tab: "按预定类型查询" }],
    eventType: [],
    selectedEventType: [],
    headers: [
      { text: "预定日期", value: "date" },
      { text: "预定类型", value: "type" },
      { text: "预定起止时间", value: "time" },
      { text: "预定人姓名", value: "name" },
      { text: "联系方式", value: "email", sortable: false },
      // { text: '资源', value: 'numOfResource' },
      { text: '人数', value: 'numOfResource' },
      { text: "状态", value: "status" },
      { text: "详情", value: "description", sortable: false },
    ],
    bookings: [],
    historyBookings: [],
    selectedTab: "",
    startMenu: "",
    endMenu: "",
    startDate: "",
    endDate: "",
    isLoading: false,
    alert: false,
    search: "",
    timer: "",
    isDetailsShow: false,
    details:{},
    selectedItem: {},
    numOfRecs: 0,
    columns: [
      {
        label: "预定日期",
        field: "date",
      },
      {
        label: "预定类型",
        field: "type",
      },
      {
        label: "预定起止时间",
        field: "time",
      },
      { label: "预定人姓名", field: "name" },
      { label: "联系方式", field: "email" },
      //  { label: '资源', field: 'numOfResource' },
      { label: "人数", field: "numOfResource" },
      { label: "状态", field: "status" },
      //{ label: "详情", field: "description" },
    ],
  }),
  async mounted() {
    this.isLoading = true;
    let list = await eventTemplateService.getEventTemplates(true);

    if (!list || list.length == 0) {
      //onfirm('您没有访问权限') &&
      this.alert = true;
      setTimeout(() => this.$router.push("/"), 2000);
    } else {
      this.eventType = list;
      this.isLoading = false;
    }
  },

  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    async run() {
      this.numOfRecs = this.bookings.length;
      this.historyBookings = JSON.parse(JSON.stringify(this.bookings));
      if (this.selectedTab == 1 && this.selectedEventType.length == 0) return;

      this.bookings = [];

      clearInterval(this.timer);

      this.timer = setInterval(this.run, 30000);

      if (!this.startDate) this.startDate = moment().format("YYYY-MM-DD");
      if (!this.endDate) this.endDate = moment().format("YYYY-MM-DD");

      if (moment(this.endDate).isBefore(moment(this.startDate)))
        this.endDate = this.startDate;

      this.isLoading = true;
      let list = [];
      if (this.selectedTab == 0) {
        const wid = process.env.VUE_APP_TYPE;

        let payload = {
          wid: wid,
          StartDateTime: this.startDate,
          EndDateTime: moment(this.endDate)
            .add("hours", 24)
            .format("YYYY-MM-DD"),
        };

        list = await reportService.getReport(payload);
      } else {
        let payload = {
          EventTemplateId: this.selectedEventType.Identity,
          StartDateTime: this.startDate,
          EndDateTime: moment(this.endDate)
            .add("hours", 24)
            .format("YYYY-MM-DD"),
        };

        list = await reportService.getReportByEventId(payload);
      }
      this.isLoading = false;

      if (list) {
        list.sort((x, y) => {
          return x.SubmissionDate < y.SubmissionDate ? 1 : -1;
        });

        this.bookings = list.map((o) => {
          return {
            identity: o.Identity,
            date: moment(o.StartDateTime).format("YYYY-MM-DD"),
            type: o.Name,
            time:
              moment(o.StartDateTime).format("HH:mm") +
              " - " +
              moment(o.EndDateTime).format("HH:mm"),
            name: o.BookerName,
            email: o.BookerEmailAddress,
            numOfResource: o.Resources.length,

            //numOfResource: o.Resources[0].Name,
            status:
              o.Status === "Accepted"
                ? "已确认"
                : o.Status === "Requested"
                ? "待审批"
                : o.Status === "Cancelled"
                ? "已取消"
                : "已拒绝",
            description: o.Description.replace(":", ""),
          };
        });
      }
      //this.bookings = this.bookings.reverse();
      // this.numOfRecs = this.bookings.length;
    },
    isNew(item) {
      if (this.numOfRecs === 0) return false;
      if (
        this.historyBookings.findIndex((x) => x.identity == item.identity) ==
          -1 &&
        this.numOfRecs != 0
      )
        return true;
      if (
        this.historyBookings.find((x) => x.identity === item.identity).status !=
        item.status
      )
        return true;
    },
    showBookingDetails(item) {
      this.selectedItem = item;
      this.isDetailsShow = true;

      console.log(item.description)
      let _descr  = item.description.replace('"isAlumni"','"isAlumni":').replace('"type""','"type":"');

      this.details = JSON.parse(_descr);      
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Report/ReportService.vue